import { render } from "./GlobalPopup.vue?vue&type=template&id=22379334&scoped=true"
import script from "./GlobalPopup.vue?vue&type=script&lang=js"
export * from "./GlobalPopup.vue?vue&type=script&lang=js"

import "./GlobalPopup.vue?vue&type=style&index=0&id=22379334&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22379334"]])

export default __exports__